(function () {
  if (window.__fabriqueStyleItInitialized) return;
  window.__fabriqueStyleItInitialized = true;

  const EXPERIMENT_ID = 'style-it-auto-match-ab';
  const modules = new WeakSet();

  function prepareCards(module, group) {
    const scope = window.crypto?.randomUUID?.() || `${Date.now()}-${Math.random()}`;
    module.querySelectorAll('[data-style-with-item] .fabrique-product-wrapper').forEach(card => {
      Object.assign(card.dataset, {
        styleItContext: 'true',
        trackModule: 'style_with',
        trackModuleType: 'list_horizontal',
        trackAbtestExperimentId: group ? EXPERIMENT_ID : '',
        trackAbtestExperimentGroup: group,
        abExperimentId: group ? EXPERIMENT_ID : '',
        abGroup: group,
        trackAddToCart: 'true',
        trackKey: `style-it:${scope}:${card.dataset.trackKey || card.dataset.handle}`,
      });
    });
  }

  async function getGroup(module) {
    if (window.Shopify?.designMode) return '';
    const started = Date.now();
    while (module.isConnected && Date.now() - started < 3000) {
      try {
        const value = window._growthbook?.getFeatureValue?.(EXPERIMENT_ID, null);
        if (value !== null && value !== undefined) return ['a', 'b'].includes(value) ? value : '';
      } catch (_error) { return ''; }
      await new Promise(resolve => window.setTimeout(resolve, 100));
    }
    return '';
  }

  async function mount(module) {
    if (modules.has(module)) return;
    modules.add(module);
    const group = await getGroup(module);
    if (!module.isConnected) return;
    const template = module.querySelector(`template[data-style-it-group="${group || 'a'}"]`);
    if (!template?.content.querySelector('product-card')) return;
    const fragment = template.content.cloneNode(true);
    const content = module.querySelector('[data-style-with-content]');
    document.adoptNode(fragment);
    customElements.upgrade(fragment);
    prepareCards(fragment, group);
    content.replaceChildren(fragment);
    module.dataset.abExperimentId = group ? EXPERIMENT_ID : '';
    module.dataset.abGroup = group;
    module.hidden = false;
    const element = content.querySelector('.fabrique-product-complete-look-swiper');
    if (element && !element.swiper && typeof window.Swiper === 'function') {
      new window.Swiper(element, {
        direction: 'horizontal', slidesPerView: 'auto', freeMode: true, grabCursor: true,
        ...(typeof window.isSafariPC === 'function' && !window.isSafariPC()
          ? { mousewheel: { forceToAxis: true } } : {}),
      });
    }
  }

  function init() {
    document.querySelectorAll('[data-style-it-module]').forEach(mount);
  }

  document.addEventListener('shopify:section:load', event => {
    event.target.querySelectorAll('[data-style-it-module]').forEach(mount);
  });
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('[data-style-it-module] .swiper').forEach(element => element.swiper?.destroy(true, true));
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
